import { tw } from "~/utils";

const WELCOME_VIDEO_SRC =
  "https://cdn.oursprivacy.com/media/videos/22ac2a4a-dd96-4f9a-8f02-aa91afde356b/video.mp4";
const WELCOME_VIDEO_POSTER =
  "https://cdn.oursprivacy.com/media/videos/22ac2a4a-dd96-4f9a-8f02-aa91afde356b/poster.jpg";
const WELCOME_VIDEO_TITLE = "Welcome to Elektra";
const WELCOME_VIDEO_SUBTITLE = "How to make the most out of your experience";

interface WelcomeVideoProps {
  className?: string;
  showHeadings?: boolean;
}

export const WelcomeVideo = ({
  className = "",
  showHeadings = false,
}: WelcomeVideoProps) => (
  <div className={tw("w-full space-y-1", className)}>
    <div className="w-full overflow-hidden rounded-lg bg-gray-100">
      <video
        src={WELCOME_VIDEO_SRC}
        poster={WELCOME_VIDEO_POSTER}
        controls
        playsInline
        preload="none"
        className="w-full rounded-lg"
      />
    </div>
    {showHeadings && (
      <>
        <h3 className="text-indigo font-sans text-sm font-semibold">
          {WELCOME_VIDEO_TITLE}
        </h3>
        <h4 className="text-indigo font-sans text-xs">
          {WELCOME_VIDEO_SUBTITLE}
        </h4>
      </>
    )}
  </div>
);
